import React from 'react';

export default function ClearBadge({ amount, children }) {
  const negative = amount < 0;

  return (
    <span
      className={`ml-1 text-white font-bold text-base py-0.5 px-2 font-sans rounded-[6px] printing-fix-spacing ${
        !negative ? 'bg-primary-500' : 'bg-[#E5844F]'
      }`}
    >
      <span className="button-content">{children}</span>
    </span>
  );
}
